export const AUTHENTICATION_EVENT = 'socialAuthenticationMessage';
export const WINDOW_NAME = 'SocialAuthenticationFlowWindow';
export const BROADCAST_CHANNEL_NAME = 'broadcastSocialAuthenticationChannel';
